export const PAGE_SIZE = 128;

export const BASE_URL = new URL("https://itskaos.com");

export const RETAILERS_PER_PAGE = 16;
